module.exports = __webpack_public_path__ + "static/img/qrCode.2bec7f0a.jpg";